module.exports = __webpack_public_path__ + "img/spinner-dark.c5fe23fa.svg";